<template>
    <div class="sheme-manage">
        <h3 class="scheme-title">
            <el-button class="back-btn back" round @click="goBackFolderList">返回</el-button>
            字段列表
            <el-tooltip class="item" effect="dark" content="字段列表中必须添加老师姓名和学生姓名字段，作为文件名称显示" placement="bottom-start">
                <i style="color: #E6A23C" class="el-icon-warning"></i>
            </el-tooltip>
        </h3>
        <el-button type="primary" class="back-btn" @click="onAddScheme">添加字段</el-button>
        <!-- <el-button class="back-btn">编辑管理员提交图片上限</el-button> -->
        <el-table
            v-loading="loading"
            :data="list"
            style="width: 100%">
            <el-table-column
                label="字段 ID"
                prop="fieldId"
                width="80">
            </el-table-column>
            <el-table-column
                label="字段内容"
                prop="fieldName">
            </el-table-column>
            <el-table-column
                label="字段类型"
                prop="fieldKey"
                width="180"
                sortable>
            </el-table-column>
            <el-table-column
                label="是否为空"
                width="180">
                <template slot-scope="scope">
                    {{ scope.row.isNull === 1 ? '可为空' : '必填' }}
                </template>
            </el-table-column>
            <el-table-column
                label="图片数量"
                width="180">
                <template slot-scope="scope">
                    {{ scope.row.photoNum || '--' }}
                </template>
            </el-table-column>
            <el-table-column
                label="用户类型"
                width="180"
                prop="userType"
                sortable>
            </el-table-column>
            <el-table-column
                label="排序"
                width="180"
                sortable
                prop="rank">
            </el-table-column>
            <el-table-column label="操作" width="200">
                <template slot-scope="scope">
                    <!-- <el-button
                    size="mini"
                    @click="handleEdit(scope.$index, scope.row)">编辑</el-button> -->
                    <el-button
                        size="mini"
                        type="danger"
                        @click="handleDelete(scope.$index, scope.row)">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
        <add-scheme
            :is-show="isAddSchemeShow"
            :levels="levels"
            :form-type-list="formTypeList"
            @hide="hideAddScheme">
        </add-scheme>
    </div>
</template>
<script>
import AddScheme from './AddScheme.vue'
import api from '@/api/index.js'
export default {
    name: 'SchemeManage',
    components: {
        AddScheme
    },
    props: {
        levels: String
    },
    data () {
        return {
            loading: false,
            list: [],
            formTypeList: [],
            isAddSchemeShow: false,
            folderId: this.levels.split(',').pop()
        }
    },
    async created () {
        this.loading = true
        await this.getFormTypeList()
        await this.getSchemeList()
        this.loading = false
    },
    methods: {
        // 获取表单类型列表
        async getFormTypeList () {
            try {
                const resp = await api.loadFormTypeList({
                    dataStatus: 1
                })
                if (resp.success) {
                    this.formTypeList = resp.data.list
                } else {
                    this.$message.error(resp.message)
                }
            } catch (error) {
                this.$message.error(resp.message)
            }
        },
        async getSchemeList () {
            try {
                const resp = await api.loadScheme({
                    folderId: this.folderId
                })
                if (resp.success) {
                    this.list = resp.data.list.filter(m => m.dataStatus === 1).map(m => {
                        m.userType = (m.userType === 1 ? '老师' : '学生')
                        m.fieldKey = this.formTypeList.find(type => type.fieldKey === m.fieldKey).fieldName
                        return m
                    })
                } else {
                    this.$message.error(resp.message)
                }
            } catch (error) {
                this.$message.error(error.message)
            }
        },
        // 添加，编辑字段
        onAddScheme () {
            this.isAddSchemeShow = true
        },
        hideAddScheme (reload) {
            if (reload) {
                this.getSchemeList()
            }
            this.isAddSchemeShow = false
        },
        handleEdit(index, row) {
            console.log(index, row);
        },
        // 删除字段
        async handleDelete(index, row) {
            console.log(index, row);
            this.$confirm(`删除后新录入的数据将没有该字段，已经添加的不受影响`, `确定要删除【${row.fieldName}】字段？`, {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(async () => {
                try {
                    const resp = await api.deleteScheme({
                        fieldId: row.fieldId,
                        folderId: this.folderId
                    })
                    if (resp.success) {
                        this.$message.success('删除字段成功');
                        this.getSchemeList()
                    } else {
                        this.$message.error(resp.message)
                    }
                } catch (error) {
                    this.$message.error(error.message)
                }
            })
        },
        goBackFolderList () {
            let meg = ''
            const ter = this.list.find(m => m.fieldName === '姓名' && m.userType === '老师')
            const stu = this.list.find(m => m.fieldName === '姓名' && m.userType === '学生')
            if (!ter) {
                meg = '字段列表中缺少 老师【姓名】字段，请手动添加，该字段将作为录入信息文件名'
            }
            if (!stu) {
                meg = '字段列表中缺少 学生【姓名】字段，请手动添加，该字段将作为录入信息文件名'
            }
            if (!ter || !stu) {
                this.$confirm(meg, {
                    confirmButtonText: '忽略返回',
                    cancelButtonText: '取消',
                    type: 'error'
                }).then(() => {
                    this.$router.push({
                        name: 'FolderList',
                        params: {
                            levels: this.$route.query.levels
                        }
                    })
                })
            } else {
                this.$router.push({
                    name: 'FolderList',
                    params: {
                        levels: this.$route.query.levels
                    }
                })
            }
            
        }
    }
}
</script>>
<style lang="scss" scopes>
.sheme-manage {
    padding: 20;
    .back-btn {
        margin-bottom: 20px;
        &.back {
            float: right;
        }
    }
    .scheme-title {
        margin-bottom: 20px;
        color: #333333;
        font-size: 16px;
    }
}
</style>